import { vacancyBanner } from "../../../shared/assets/img";
import styles from "./VacancyBanner.module.scss";
import { Container, SliceBorder, IconButton } from "../../../shared/ui";
import { borderData } from "../consts";
import { Link, useNavigate } from "react-router-dom";
import { getRouteVacancies } from "../../../shared/constants/routes";
import { useMediaQuery } from "../../../shared/hooks/useMediaQuery";
import { MediaQueryProperty, MediaSizeEnum } from "../../../shared/constants/media";
import { generateMediaQuery } from "../../../shared/lib/helpers";

export const VacancyBanner = () => {
    const isTablet = useMediaQuery(generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.md));
    const isMobile = useMediaQuery(`(max-width: 585px)`);

    const navigate = useNavigate();

    const handleClick = () => {
        navigate(getRouteVacancies());
    };

    return (
        <div>
            {isMobile && (
                <Link className={styles.link} to={getRouteVacancies()}>
                    Вернуться к&nbsp;списку вакансий
                </Link>
            )}
            <Container className={styles.wrapper}>
                {!isMobile && (
                    <SliceBorder
                        sizeRadius={isTablet ? 20 : 25}
                        multiplierInside={1}
                        border={borderData}
                        className={styles.sliceBorder}
                    >
                        <IconButton
                            onClick={handleClick}
                            icon="left"
                            theme="light"
                            text="Вернуться к списку вакансий"
                        />
                    </SliceBorder>
                )}
                <img src={vacancyBanner} alt="баннер страницы вакансии" className={styles.background} />
            </Container>
        </div>
    );
};
